import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import {
  FormFieldNewComponent,
  PhoneAuthorizedUserDirective,
  PhoneMaskFixDirective,
  SdvorCheckboxComponent,
} from '@sdvor/shared/ui';
import { UrlModule } from '@spartacus/core';
import { FormErrorsComponent } from '@spartacus/storefront';
import { provideNgxMask } from 'ngx-mask';
import { SdvorSubmitOrderModule } from '../submit-order';
import { SdvorCheckoutContactsComponent } from './checkout-contacts.component';

@NgModule({
  imports: [
    NgIf,
    AsyncPipe,
    RouterLink,
    FormFieldNewComponent,
    ReactiveFormsModule,
    FormErrorsComponent,
    SdvorSubmitOrderModule,
    SdvorCheckboxComponent,
    UrlModule,
    PhoneMaskFixDirective,
    PhoneAuthorizedUserDirective,
  ],
  providers: [provideNgxMask()],
  declarations: [SdvorCheckoutContactsComponent],
  exports: [SdvorCheckoutContactsComponent],
})
export class SdvorCheckoutContactsModule {}
